import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';

import Button from '@/components/Button';
import GeneralLoading from '@/components/GeneralLoading';

interface PreviewProps {
  file: File;
  deleteFile: (index: number) => void;
}

interface DropzoneImageProps {
  onChange: (file: File) => void;
  onReset: () => void;
  currentImage?: File | null;
}

const DropzoneImage = ({ onChange, onReset, currentImage }: DropzoneImageProps) => {
  // const [loading, setLoading] = useState(false);
  const [fileAccepted, setFileAccepted] = useState<File | null>(currentImage || null);
  const loading = false;

  const handleFilesAccepted = (newFile: File[]) => {
    setFileAccepted(newFile[0]);
    onChange(newFile[0]);
  };

  const deleteFile = () => {
    setFileAccepted(null);
    onReset();
  };

  useEffect(() => {
    setFileAccepted(currentImage || null);
  }, [currentImage]);

  return (
    <div style={{ marginTop: '1rem' }}>
      {loading ? (
        <GeneralLoading size={100} text="Cargando" withDots fontVariant="h5" />
      ) : (
        <Dropzone
          onDrop={(acceptedFiles: File[]) => handleFilesAccepted(acceptedFiles)} // Aca es donde se reciben los archivos que se suben, el formato es "File[]", osea un array de File
          accept={{ 'image/*': ['.jpg', '.jpeg', '.png'] }} // Formatos aceptados
          // onDropAccepted={() => setDropAccepted(true)} // Aca se ejecuta la funcion que se encarga de subir los archivos
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              {fileAccepted ? (
                <Grid
                  container
                  sx={{
                    display: 'flex',
                    alignItems: 'start',
                    justifyContent: 'center',
                    padding: '1rem',
                    gap: '0.5rem',
                  }}
                >
                  <Preview file={fileAccepted} deleteFile={deleteFile} />
                </Grid>
              ) : (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <InputContent />
                </div>
              )}
            </section>
          )}
        </Dropzone>
      )}
    </div>
  );
};

export default DropzoneImage;

const InputContent = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px dashed',
        borderColor: theme.palette.primary.main,
        padding: '1rem',
        borderRadius: '0.5rem',
        gap: '0.5rem',
        textAlign: 'center',
        cursor: 'pointer',
      }}
    >
      <AddAPhotoIcon color="primary" style={{ fontSize: '2rem' }} />
      <Typography variant="body2" color={theme.palette.secondary.main}>
        Agrega o arrastra tu foto aquí.
      </Typography>
    </Box>
  );
};

const Preview = ({ file, deleteFile }: PreviewProps) => {
  const path = URL.createObjectURL(file);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', alignItems: 'center' }}>
      <img
        src={path}
        style={{ width: '95px', height: '95px', borderRadius: '1rem', objectFit: 'cover' }}
      />
      <Button onClick={deleteFile} size="small" variant="outlined" color="error">
        <DeleteOutlineIcon color="error" />
      </Button>
    </Box>
  );
};
